import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

export const MATaxViewTaxForm = props => (
  <GlobalViewTaxForm
    {...props}
    countryCode={Constants.CountryCode.MA}
    showTaxCert={false}
  />
);

MATaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
